export const SET_END_OF_ROUND = "SET_END_OF_ROUND";
export const SET_GAME_IN_PROGRESS = "SET_GAME_IN_PROGRESS";
export const RESET_GAME = "RESET_GAME";
export const START_NEXT_ROUND = "START_NEXT_ROUND";
export const SET_STATUS_MESSAGE = "SET_STATUS_MESSAGE";
export const SET_SHOW_MARKER = "SET_SHOW_MARKER";
export const SET_REMAINING_DISTANCE = "SET_REMAINING_DISTANCE";
export const SET_PLACED_CITIES_COUNTER = "SET_PLACED_CITIES_COUNTER";
export const SET_CURRENT_POSITION = "SET_CURRENT_POSITION";
export const SET_DISTANCE_BETWEEN_POSITIONS = "SET_DISTANCE_BETWEEN_POSITIONS";
